import { Fragment, memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IconButton } from 'basic-components';
import { Clear } from 'basic-components/icons';

import { statusesActions } from 'actions/modules/statuses';

import History from './History';
import MainView from './MainView';
import SeeAll from './SeeAll';
import StatusDetails from './StatusDetails';
import StatusesRoutingMobile from './StatusesRoutingMobile';

import { When } from 'react-if';

import classNames from 'classnames';
import './Statuses.scss';

const Statuses = () => {
  const dispatch = useDispatch(),
        expanded = useSelector(state => state.statusesState.open),
        mode = useSelector(state => state.statusesState.mode),
        isMobile = useSelector(state => state.globalState.isMobile),
        setExpandedFalse = useCallback(() => dispatch(statusesActions.changeValue(false, 'open')), [dispatch])

  useEffect(() => {
    !expanded && dispatch(statusesActions.clear())
  }, [expanded, dispatch])

  return (
    <Fragment>
      <div 
          className={classNames(
            "statuses",
            { "statuses--is-expanded": expanded && !isMobile }
          )}
      >
        <When condition={expanded && !isMobile}>
          {() => (
            <Fragment>
              <IconButton
                  className="statuses__close-button"
                  onClick={setExpandedFalse}
              >
                <Clear
                    color="grey-medium"
                    height={16}
                    width={16}
                />
              </IconButton>
              <When condition={mode === statusesActions.MODES.MAIN}>
                {() => (
                  <MainView/>
                )}
              </When>
              <When condition={mode === statusesActions.MODES.DETAILS}>
                {() => (
                  <StatusDetails/>
                )}
              </When>
              <When condition={mode === statusesActions.MODES.HISTORY}>
                {() => (
                  <History/>
                )}
              </When>
              <When condition={mode === statusesActions.MODES.SEE_ALL}>
                {() => (
                  <SeeAll/>
                )}
              </When>
            </Fragment>
          )}
        </When>
      </div>
      <When condition={expanded && !isMobile}>
        {() => (
          <div 
              className="statuses-background"
              onClick={setExpandedFalse}
          />
        )}
      </When>
      <When condition={isMobile}>
        <StatusesRoutingMobile/>
      </When>
    </Fragment>
  )
}

export default memo(Statuses);